import { SuomifiTheme, defaultSuomifiTheme } from 'suomifi-ui-components'

// Currently todistus theme structure is identical to the Suomifi theme, but can be extended as needed
// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface TodistusTheme extends SuomifiTheme {}

export const todistusTheme: TodistusTheme = defaultSuomifiTheme
